module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar header          = config.header || {};\nvar headerButtons   = header.buttons || {};\nvar footer          = config.footer || {};\nvar footerButtons   = footer.buttons || {};\nvar button;\nvar additionalClasses = [];\nif(config.separatorMode === 'inline'){\nadditionalClasses.push('inline');\n}\nif((config.availableSeparators || {}).type === 'single'){\nadditionalClasses.push('isSingle');\n}\nconst contentCssClasses = ['content']\n%><div class=\"<%= additionalClasses.join(' '); %>\"><%\nif(!!config.header){\n%>\n<div class=\"header\">\n<%\nif(header.titleKey){\n%><%- include('../../../base/form/elements/label', { model: { label: __(header.titleKey) } }); %><%\n}\n%>\n<div class=\"buttons\">\n<%\nif((button = headerButtons.add)){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: button.buttonType, context: button.entityContext, symbolOnly: button.symbolOnly } }); %><%\n}\n%>\n</div>\n</div>\n<%\n}\n%>\n<div class=\"<%- contentCssClasses.join(' ') %>\"></div>\n<%\nif(!!config.footer){\n%>\n<div class=\"footer\">\n<%\nif((button = footerButtons.add)){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: button.buttonType, context: button.entityContext, symbolOnly: button.symbolOnly } }); %><%\n}\n%>\n</div>\n<%\n}\n%></div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\relationship.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var header          = config.header || {};
var headerButtons   = header.buttons || {};
var footer          = config.footer || {};
var footerButtons   = footer.buttons || {};
var button;
var additionalClasses = [];
if(config.separatorMode === 'inline'){
additionalClasses.push('inline');
}
if((config.availableSeparators || {}).type === 'single'){
additionalClasses.push('isSingle');
}
const contentCssClasses = ['content']

    ; __line = 15
    ; __append("<div class=\"")
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">")
    ; 
if(!!config.header){

    ; __line = 17
    ; __append("\n<div class=\"header\">\n")
    ; __line = 19
    ; 
if(header.titleKey){

    ; __line = 21
    ; __append( include('../../../base/form/elements/label', { model: { label: __(header.titleKey) } }) )
    ; 
}

    ; __line = 23
    ; __append("\n<div class=\"buttons\">\n")
    ; __line = 25
    ; 
if((button = headerButtons.add)){

    ; __line = 27
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: button.buttonType, context: button.entityContext, symbolOnly: button.symbolOnly } }) )
    ; 
}

    ; __line = 29
    ; __append("\n</div>\n</div>\n")
    ; __line = 32
    ; 
}

    ; __line = 34
    ; __append("\n<div class=\"")
    ; __line = 35
    ; __append( contentCssClasses.join(' ') )
    ; __append("\"></div>\n")
    ; __line = 36
    ; 
if(!!config.footer){

    ; __line = 38
    ; __append("\n<div class=\"footer\">\n")
    ; __line = 40
    ; 
if((button = footerButtons.add)){

    ; __line = 42
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: button.buttonType, context: button.entityContext, symbolOnly: button.symbolOnly } }) )
    ; 
}

    ; __line = 44
    ; __append("\n</div>\n")
    ; __line = 46
    ; 
}

    ; __line = 48
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\relationship.ejs

}